export default "__VITE_ASSET__BmkbUgVr__"